<template>
  <a-layout style="padding: 24px 0; background: #fff; margin: 0 2rem 0 2rem">
    <a-layout-sider width="200" style="background: #fff">
      <a-menu
        mode="inline"
        :default-selected-keys="['1']"
        :default-open-keys="['sub1']"
        style="height: 100%"
        @select="onSelect"
        v-model="selectedKeys"
      >
        <a-menu-item key="changePwd">
          <a-icon type="security-scan" /> 修改密码
        </a-menu-item>
        <a-menu-item key="setAPI"> <a-icon type="api" /> API接口 </a-menu-item>
      </a-menu>
    </a-layout-sider>
    <a-layout-content :style="{ padding: '0 24px', minHeight: '280px' }">
      <router-view></router-view>
    </a-layout-content>
  </a-layout>
</template>

<script>
export default {
  data() {
    return {
      selectedKeys: []
    }
  },
  methods: {
    onSelect(select) {
      this.$router.push('/setting/' + select.key)
    }
  },
  mounted() {
    this.selectedKeys = [this.$route.path.split('/')[2]]
  }
}
</script>

<style>
</style>
